import CONSTANTS from '../constants'
import {
    getRequest, 
    postRequest
} from '../../services'
import { APICONFIG } from '../config/apiConfig'

// GET VEHICLE LIST DETAILS
export const getWarningDetails = (id) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_WARNING_DETAIL_REQUEST })
    return getRequest(`${APICONFIG.getWarningDetail}/${id}`).then((res) => {
        dispatch({ type: CONSTANTS.GET_WARNING_DETAIL_SUCCESS, data: res.data })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_WARNING_DETAIL_FAILURE })
        return err
    })
}

//pave-web-get-facility-rate for get facility
export const getFacilityRateDetails = (data) => (dispatch) => {
    let payload = { ...data, 'device_type': 'web' }
	dispatch({ type: CONSTANTS.GET_RATE_FACILITY_REQUEST })
	return postRequest(APICONFIG.getFaclityUrl, payload).then((res) => {
		dispatch({ type: CONSTANTS.GET_RATE_FACILITY_SUCCESS, data: res.data })
		return res
	}).catch((err) => {
		dispatch({ type: CONSTANTS.GET_RATE_FACILITY_FAILURE, errorMessage: '' })
		return err
	})
}